<template>
  <div class="home">
    <Header />
    <SOS />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import SOS from '@/components/SOS.vue'

export default {
  name: 'Home',
  components: {
    Header,
    SOS
  },
}
</script>
